import React from 'react';
import { ReactComponent as File } from './logo.svg';
import PortalLogo from 'src/PlatformPortal/PortalLogo';

interface LogoProps {
  width?: number;
  height?: number;
}

export default function Logo({ width = 135, height = 37 }: LogoProps) {
  return (
    <PortalLogo
      fallback={<File width={width} height={height} />}
      width={width}
      height={height}
    />
  );
}
